// CuisineDropdown.jsx
import React, { useState, useEffect } from 'react';
import { CustomDropdown } from './Customdropdown';
import styles from "./editandcreate.module.css";

export const CuisineDropdown = ({ 
  value, 
  onChange, 
  cuisines = [],
  placeholder = "Select cuisine type",
  width = '100%'
}) => {
  const [search, setSearch] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);

  // Set initial search value when value changes
  useEffect(() => {
    if (value) {
      const selectedCuisine = cuisines.find(c => c.type_id === value);
      if (selectedCuisine) {
        setSearch(selectedCuisine.type_name);
      }
    }
  }, [value, cuisines]);

  const filteredCuisines = cuisines.filter(cuisine => 
    cuisine.type_name?.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (option) => {
    onChange(option.value);
    setSearch(option.label);
    setShowDropdown(false);
  };

  const handleToggleDropdown = (show) => {
    setShowDropdown(show);
    if (show) {
      setSearch('');
    }
  };

  return (
    <CustomDropdown
      searchValue={search}
      onSearchChange={setSearch}
      showDropdown={showDropdown}
      onToggleDropdown={handleToggleDropdown}
      options={filteredCuisines.map(cuisine => ({
        value: cuisine.type_id,
        label: cuisine.type_name,
        name: cuisine.type_name
      }))}
      onSelect={handleSelect}
      placeholder={placeholder}
      width={width}
    />
  );
};